// extracted by mini-css-extract-plugin
export default {"block":"hXezM","readOnlyBlock":"HYs3P","item":"dVGKY","itemOrder":"lfRdL","itemText":"x8TYQ"};